module.exports = __webpack_public_path__ + "static/media/login-bg.f2be1ed6.png";